var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{ref:"image",class:_vm.coverImage ? 'image-container' : 'image-container-logo',attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }